export const ONE_SECOND = 1000 * 1;
export const ONE_MINUTE = ONE_SECOND * 60;
export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;
export const ONE_WEEK = ONE_DAY * 7;
export const ONE_MONTH = ONE_DAY * 30;
export const SIX_MONTHS = ONE_MONTH * 6;
export const ONE_YEAR = ONE_DAY * 365;
export const _180_DAYS = ONE_DAY * 180;

export function getWindowObject() {
  return typeof window !== "undefined" ? window : {};
}

export function getQueryStringParams(key = null) {
  const global = getWindowObject();
  const search = global.location && global.location.search || "";
  const nameValues = search.replace("?", "").split("&");
  const pairs = (nameValues || []).map((pair) => {
    const [name, value=""] = pair.split("=");
    return {name, value};
  });
  const params = pairs.reduce((coll, item) => {
    if (item.name) {
      coll[item.name] = item.value;
    }
    return coll;
  }, {});

  if (!key) {
    return params;
  }

  return params[key] || "";
}

export function parseDate(dateTimeStr) {
  // Parse Format 2011-06-21T00:00:00 to {month, day, year}
  const parseDateRE = /^(\d{4})-(\d{2})-(\d{2})/;
  const noLeadingZeroRE = /^0?(\d+)$/;
  const result = parseDateRE.exec(dateTimeStr);
  const [ fullDate="", year="", monthLeadingZero="", dayLeadingZero="" ] = result || [];
  const dayResult = noLeadingZeroRE.exec(dayLeadingZero);
  const monthResult = noLeadingZeroRE.exec(monthLeadingZero);

  const [ ,day="" ] = dayResult || [];
  const [ ,month="" ] = monthResult || [];
  
  return {fullDate, year, month, day, monthLeadingZero, dayLeadingZero};
}

export function dateAfterYear(dateTimeStr, yearTarget) {
  const { year } = parseDate(dateTimeStr);
  return +year > +yearTarget;
}

export function dateDiffIsGreaterThan(dateTimeStartStr, dateTimeEndStr, diffVal, isGreaterEqualTo = true) {
  const startDateTime = Date.parse(dateTimeStartStr);
  const endDateTime = Date.parse(dateTimeEndStr);
  const diffTime = endDateTime - startDateTime;

  if (diffTime < 0) {
    return null;
  }

  if (isGreaterEqualTo && diffTime === 0) {
    return true;
  } 

  return +diffTime > +diffVal;
}

export function getMonthName(monthVal) {
  try {
    const monthNames = [ "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December" ];
  
    const leadingZeroRE = /^0?(\d{1,2})/;
    const monthIndex = (+('' + monthVal).replace(leadingZeroRE, "$1") - 1);
  
    if (monthIndex < 0 || monthIndex >= 12) {
      throw Error("Index out of range");
    }
  
    return monthNames[monthIndex] || "";
  } catch (err) {
    // TODO: Log Error
    return "";
  }
}

export function isEmpty(target) {
  if (Array.isArray(target)) {
    return !target.length;
  } else if (typeof target === "object") {
    return !Object.keys(target);
  }

  return !target;
}

export function delay(ms) {
  return new Promise((res) => {
    setTimeout(res, ms);
  });
}

export function toKeyedCollection(list, prop) {
  const newList = list.reduce((collection, item) => {
    if (item[prop]) {
      const key = item[prop];
      collection[key] = item;
    }

    return collection;
  }, {});

  return newList;
}

export function mergeData(obj1, obj2) {
  return Object.assign({}, obj1, obj2);
}

export function isSignIn() {
  try {
    return !!window.mscPastSettings 
      && typeof window.mscPastSettings.is_auth !== "undefined"
      && window.mscPastSettings.is_auth;

    // return window.document.getElementById('wv-authnav').getAttribute('data-is-loggedin') === "true";
  } catch(err) {
    return false;
  }
}

export const compare = (val1, val2, operator = "===", caseSensitive = false) => {
  const comparision = (a, b) => {
    switch (operator) {
      case ">":
        return a > b;
      case "<":
        return a < b;
      case ">=":
        return a >= b;
      case "<=": 
        return a <= b;
      case "!=":
        return a != b;
      case "!==":
        return a !== b;
      case "==":
        return a == b;
      case "===":
      default:
        return a === b;
    }
  };
  const isStr = val => typeof val === "string";
  
  if (isStr(val1) && isStr(val2)) {
    return caseSensitive ? comparision(val1, val2) : comparision(val1.toLowerCase(), val2.toLowerCase());
  }

  // TODO: Include Object And Array Comparisions

  return comparision(val1, val2);
};

export const isInteractiveKeyCode = (e) => {
  const keyCode = e.keyCode;
  return keyCode === 13 || keyCode === 32;
};
    
export const replacePronouns = (text, gender, replaceTokens) => {
  if (!text || !gender) {
    return text;
  }

  const pronounSets = ["heshe","himher","hisher","hishers"];

  const genderPronouns = {
    "male": ["he", "him", "his", "his"],
    "female": ["she", "her", "her", "hers"]
  };

  const selectedPronouns = genderPronouns[gender.toLowerCase()];
  return pronounSets.reduce((txt, key, index) => {
    const token = replaceTokens[key];
    const pronoun = selectedPronouns[index];
    return txt.replace(new RegExp(token,'g'), pronoun);
  }, text);
};

export const monthNumToName = (monthnum) => {
  var months = [
    'January', 'February', 'March', 'April', 'May',
    'June', 'July', 'August', 'September',
    'October', 'November', 'December'
    ]; 
  return months[monthnum - 1] || '';
};

export const getDateAsMonthYear = (fullDate) => {
  const date = fullDate.split("-");
  const year = date[0];
  const month = monthNumToName(date[1]);
  
  return month + " " + year;
};